import axios from "../axios";

const API_PREFIXES = ["api/admin"];

async function requestWithFallback(method, path, payload) {
  let lastError = null;

  for (let i = 0; i < API_PREFIXES.length; i += 1) {
    const prefix = API_PREFIXES[i];

    try {
      const response = await axios({
        method,
        url: window.hostname + prefix + path,
        data: payload,
      });

      return response;
    } catch (error) {
      lastError = error;
      const statusCode = error && error.response ? error.response.status : null;
      if (statusCode !== 404 || i === API_PREFIXES.length - 1) {
        throw error;
      }
    }
  }

  throw lastError;
}

export async function updateOffstreetPermitConfig(payload) {
  return requestWithFallback("put", "/offstreet/permit-config", payload);
}

export async function updateOffstreetPropertyConfig(payload) {
  return requestWithFallback("put", "/offstreet/property-config", payload);
}

export async function triggerOffstreetSync(payload) {
  return requestWithFallback("post", "/offstreet/sync", payload);
}

export async function fetchOffstreetSubscriptionSyncStatus(payload) {
  return requestWithFallback("post", "/offstreet/subscription-sync-status", payload);
}

export async function recreateOffstreetSubscription(payload) {
  return requestWithFallback("post", "/offstreet/recreate-subscription", payload);
}

export async function retryFailedOffstreetRecreates(payload) {
  return requestWithFallback("post", "/offstreet/retry-failed-recreates", payload);
}

export async function retryPendingOffstreetVoids(payload) {
  return requestWithFallback("post", "/offstreet/retry-pending-voids", payload);
}
